import React from 'react';
import cn from 'classnames';

import MessageDocument from '../MessageDocument';

import styles from './MessageMediaFallback.module.scss';

export type MessageMediaFallbackProps = {
  url: string;
  filename: string;
  size: number;
  variant: 'default' | 'user';
  className?: string;
};

const MessageMediaFallback: React.FC<MessageMediaFallbackProps> = ({
  url,
  filename,
  size,
  variant,
  className
}) => {
  return (
    <div className={cn(styles['media-fallback'], className)}>
      <MessageDocument
        url={url}
        filename={filename}
        size={size}
        variant={variant}
      />
    </div>
  );
};

export default React.memo(MessageMediaFallback);
